import { render, staticRenderFns } from "./AccommodationsList.vue?vue&type=template&id=5f42ff2e"
import script from "./AccommodationsList.vue?vue&type=script&lang=js"
export * from "./AccommodationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports